import { Component, h, Prop } from '@stencil/core';


@Component({
    tag: 'lilu-inspiration-tile',
    styleUrl: 'lilu-inspiration-tile.scss',
    shadow: true
})
export class LiluInspirationTile {

    @Prop() inspirationLink = '';
    @Prop() type = '';

    render() {
      if(this.type === 'grid') {
        return (
          <a class="inspiration-tile" href={this.inspirationLink}>
            <slot></slot>
          </a>
        );
      } else {
        return (
          <div class="inspiration-tile inspiration-slider">
            <slot></slot>
          </div>
        )
      }
    }
}
